<template>
  <div>
    <BlHeaderMv
      class="fixed top-0 w-full shadow bg-white p-8"
      icon="ico_ui_cross"
      title="Syarat dan Ketentuan"
      border-bottom
      @click="$router.go(-1)"
    />
    <div style="padding-top: 60px" class="overflow-y-auto max-h-screen">
      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Syarat dan Ketentuan Penggunaan Kartu Prakerja</BlTextAv>
        <BlTextAv class="mb-12 leading-5">
          Sebelum memutuskan untuk mengikuti Pelatihan yang disediakan untuk Program Kartu Prakerja maka Pengguna wajib terlebih dahulu
          mempelajari Syarat dan Ketentuan Penggunaan Kartu Prakerja.
        </BlTextAv>
        <BlTextAv class="mb-12 leading-5">
          Syarat dan Ketentuan Penggunaan Kartu Prakerja ini merupakan bagian dari Aturan Penggunaan Bukalapak. Pengguna Pelatihan tunduk
          pada Syarat dan Ketentuan serta Kebijakan Privasi Bukalapak dan Syarat dan Ketentuan Penggunaan Kartu Prakerja sebagaimana
          tertulis dibawah ini.
        </BlTextAv>
        <BlTextAv class="mb-12 leading-5">
          Dengan menggunakan Kartu Prakerja untuk pelatihan yang tersedia pada Platform Bukalapak maka, Pengguna telah dianggap telah
          membaca, mengerti, dan memahami dan menyetujui semua isi dalam Syarat dan Ketentuan Penggunaan Kartu Prakerja ini serta segala
          perubahannya yang terjadi di kemudian hari.
        </BlTextAv>
        <BlTextAv class="mb-12 leading-5 mt-4" variation="body-16" weight="semi-bold">Definisi</BlTextAv>
        <BlTextListMv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Bukalapak</b>
            adalah PT Bukalapak.com yang merupakan perseroan terbatas yang bergerak di bidang usaha web portal yang menyediakan portal
            jual-beli online (e-commerce) pada Platform Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Kartu Prakerja</b>
            adalah penanda atau identitas yang diberikan kepada penerima manfaat Program Kartu Prakerja.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Program Kartu Prakerja</b>
            adalah program pengembangan kompetensi kerja dan kewirausahaan yang ditujukan untuk pencari kerja, pekerja/buruh yang terkena
            pemutusan hubungan kerja, dan/atau pekerja/buruh yang membutuhkan peningkatan kompetensi.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Penerima Kartu Prakerja</b>
            adalah pemegang Kartu Prakerja yang sah atau pihak yang telah lulus Tes dan Seleksi Gelombang dan menerima persetujuan Bantuan
            Pelatihan untuk dipergunakan membeli atau membayar Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Pengguna</b>
            adalah pihak yang terdaftar/tidak terdaftar mengakses Platform Bukalapak untuk menggunakan layanan pelatihan dan sudah mempunyai
            kartu Prakerja.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Platform Bukalapak</b>
            adalah situs resmi bukalapak.com dan seluruh microsite resmi beserta aplikasi resmi Bukalapak (berbasis Android dan iOS) yang
            dapat diakses melalui perangkat komputer dan/atau perangkat seluler Pengguna dan merupakan mitra resmi pemerintah dalam
            pelaksanaan Program Kartu Prakerja yang dilakukan melalui aplikasi dan situs internet dan/atau layanan konten lainnya berbasis
            internet.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Aturan Penggunaan</b>
            adalah perjanjian antara Pengguna dan Bukalapak yang berisi seperangkat peraturan yang mengatur hak, kewajiban, tanggung jawab
            Pengguna dan Bukalapak, serta tata cara penggunaan sistem layanan Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Pelatihan</b>
            adalah keseluruhan kegiatan untuk memperoleh, meningkatkan, serta mengembangkan Kompetensi Kerja, produktivitas, disiplin,
            sikap, dan etos kerja pada tingkat keterampilan dan keahlian tertentu, yang diselenggarakan oleh Penyelenggara Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Bantuan Pelatihan</b>
            adalah bantuan dalam bentuk saldo nontunai pada Platform Digital untuk digunakan Penerima Kartu Prakerja untuk mengikuti
            Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Penyelenggara Pelatihan</b>
            atau
            <b>Lembaga Pelatihan</b>
            adalah pihak yang menyelenggarakan Pelatihan yang telah disetujui oleh Manajemen Pelaksana untuk bergabung dalam Program Kartu
            Prakerja dan bermitra dengan Platform Digital.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Sertifikat Pelatihan</b>
            adalah bukti tertulis yang diberikan oleh Lembaga Pelatihan kepada peserta Pelatihan yang telah lulus dan/atau telah selesai
            mengikuti Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            <b>Komite Cipta Kerja</b>
            adalah Komite yang dibentuk oleh Presiden untuk menyelenggarakan Program Kartu Prakerja berdasarkan Perpres Prakerja.
          </BlTextAv>
        </BlTextListMv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Pernyataan Kebenaran dan Tanggung Jawab</BlTextAv>
        <BlTextAv class="mb-12 leading-5">
          Dengan menggunakan Pelatihan pada Platform Bukalapak, Pengguna menyatakan bahwa semua informasi yang digunakan dalam mengikuti
          Pelatihan ini adalah benar dan tepat. Pengguna bertanggung jawab penuh apabila dikemudian hari terjadi sesuatu hal sehubungan
          dengan ketidakbenaran data yang Pengguna berikan.
        </BlTextAv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Ketidakandalan Informasi</BlTextAv>
        <BlTextAv class="mb-12 leading-5">
          Informasi Pelatihan yang tersedia pada Platform Bukalapak merupakan informasi umum dan tidak dimaksudkan untuk memberikan anjuran
          tertentu yang harus pengguna Andalkan. Bukalapak tidak memberikan pernyataan, jaminan, dan garansi untuk hasil dari Pelatihan.
          Bukalapak dengan ini hanya sebagai penyedia Platform Digital, bukan sebagai Lembaga Pelatihan yang menyediakan materi Pelatihan.
        </BlTextAv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Syarat dan Ketentuan Umum</BlTextAv>
        <BlTextListMv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna dengan ini menyatakan dan menjamin bahwa penggunaan Kartu Prakerja atas namanya pada Platform Digital hanya akan
            digunakan untuk diri Penerima Manfaat sendiri dan bukan untuk orang lain.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Syarat dan Ketentuan ini dapat berubah dan/atau diperbaharui sewaktu – waktu.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Dengan menggunakan layanan ini di Bukalapak, Pengguna juga tunduk dan patuh terhadap Syarat dan Ketentuan Kartu Prakerja yang
            terdapat pada situs prakerja.go.id
          </BlTextAv>
        </BlTextListMv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Penggunaan Kartu Prakerja</BlTextAv>
        <BlTextListMv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Per tanggal 1 September 2023, 1 (satu) nomor Prakerja hanya diperbolehkan untuk melakukan pembelian pelatihan prakerja
            menggunakan 1 akun Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna yang telah disetujui untuk mendapatkan Kartu Prakerja berdasarkan keputusan Pemerintah akan menerima Kartu Prakerja
            dalam bentuk digital serta mendapatkan konfirmasi besaran Bantuan Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna dapat menggunakan Kartu Prakerja untuk membeli Pelatihan yang sesuai dengan besaran bantuan pada Platform Bukalapak
            dengan memasukan nomor yang tertera pada Kartu Prakerja.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna yang telah membeli Pelatihan menggunakan Kartu Prakerja akan menerima notifikasi konfirmasi transaksi berhasil.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna wajib mengikuti Pelatihan yang telah dibeli menggunakan Kartu Prakerja sesuai dengan jadwal dan durasi yang telah
            ditetapkan oleh pihak penyelenggara pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna wajib mengikuti setiap pelatihan yang telah dibeli tanpa diwakilkan oleh pihak lain.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna yang ingin mengikuti program Pelatihan lainnya wajib untuk menyelesaikan program Pelatihan sebelumnya.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna tidak dapat membatalkan jenis pelatihan dan Lembaga Pelatihan yang telah dipilih Pengguna sesuai dengan poin nomor 4
            diatas.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna berhak mendapatkan sertifikat pelatihan setelah menyelesaikan Pelatihan yang diterbitkan oleh Lembaga Pelatihan.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pemerintah mempunyai hak penuh untuk mencabut penerima manfaat Kartu Prakerja jika Pengguna tidak sesuai dengan ketentuan yang
            ditetapkan oleh Pemerintah.
          </BlTextAv>
        </BlTextListMv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">
          Perubahan Syarat dan Ketentuan Penggunaan Kartu Prakerja
        </BlTextAv>
        <BlTextListMv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Bukalapak berhak sewaktu-waktu mengadakan perubahan, penambahan, dan/atau pembaharuan atas Syarat dan Ketentuan Penggunaan Kartu
            Prakerja yang akan dicantumkan pada Platform Bukalapak. Keberlakuan syarat dan ketentuan ini mengacu dan tunduk pada Aturan
            Penggunaan Bukalapak dan Kebijakan Privasi Bukalapak. Bukalapak menyarankan agar Pengguna membaca secara seksama dengan
            memeriksa Syarat dan Ketentuan ini dari waktu ke waktu untuk mengetahui perubahan apapun di kemudian hari.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Segala ketentuan dan/atau aturan yang berlaku dalam menggunakan Platform Bukalapak, termasuk tetapi tidak terbatas pada Aturan
            Penggunaan Bukalapak, Cara Berjualan, Cara Belanja, Kebijakan Privasi Bukalapak, serta seluruh perubahan dan penambahannya dari
            waktu ke waktu, merupakan suatu kesatuan yang tidak terpisahkan dengan Syarat dan Ketentuan Penggunaan Kartu Prakerja.
          </BlTextAv>
        </BlTextListMv>
      </div>

      <div class="bg-ui-light p-4 border-t border-0 border-gray-5 border-solid" />

      <div class="p-20">
        <BlTextAv class="mb-12 leading-5" variation="body-16" weight="semi-bold">Pernyataan dan Jaminan</BlTextAv>
        <BlTextAv class="mb-12 leading-5">Pengguna dengan ini menyatakan dan menjamin:</BlTextAv>
        <BlTextListMv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Setuju untuk mengikatkan diri pada Syarat dan Ketentuan Penggunaan Kartu Prakerja, Aturan Penggunaan Bukalapak, dana Kebijakan
            Privasi Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Bukalapak beserta afiliasi dan anak perusahaan akan dibebaskan dari segala tuntutan dan kerugian yang ditimbulkan akibat dari
            Pelatihan yang diikuti oleh Pengguna.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Bahwa Pengguna telah menyadari sepenuhnya atas segala akibat hukum dari Syarat dan Ketentuan Penggunaan Kartu Prakerja ini serta
            menyatakan telah memahami mengenai Syarat dan Ketentuan Penggunaan Kartu Prakerja ini adalah benar, lengkap, dan jelas.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna dengan ini setuju untuk memberikan data dan informasi pribadi termasuk namun tidak terbatas pada hasil ulasan dan
            penilaian layanan Pelatihan ini.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Pengguna dengan ini setuju bahwa Bukalapak dan anak perusahaan termasuk afiliasi dapat mengumpulkan, menggunakan, mengakses,
            menyimpan, dan/atau memproses data Pengguna termasuk namun tidak terbatas pada informasi pribadi tentang penggunaan layanan
            Pelatihan pada Platform Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Bukalapak berhak untuk mengungkapkan informasi, hasil pengawasan dan evaluasi Pelatihan Pengguna secara faktual berdasarkan
            kapabilitas sistem Bukalapak dalam keikutsertaanya pada layanan Pelatihan kepada namun tidak terbatas pada pihak ketiga yang
            telah mendapatkan persetujuan dari pemerintah untuk mendukung pelaksanaan program Kartu Prakerja maupun Pemerintah, baik untuk
            kepentingan penggunaan Kartu Prakerja dan/atau peningkatan layanan di Bukalapak. Untuk lebih lengkapnya dapat dilihat pada
            Kebijakan Privasi Bukalapak.
          </BlTextAv>
          <BlTextAv class="mb-12 leading-5" tag="li">
            Bukalapak tidak menjamin Pengguna mendapatkan pekerjaan, penambahan keterampilan, dan/atau pengetahuan, setelah mengikuti
            Pelatihan di Platform Bukalapak.
          </BlTextAv>
        </BlTextListMv>
      </div>
      <div style="padding-bottom: 60px"></div>
    </div>

    <footer class="w-full fixed bottom-0 ph-20 pv-12 border-t border-0 border-gray-0 bg-white" style="max-width: 480px">
      <BlButtonAv id="go-detail" variation="primary" fullwidth @click="goToDetailPage">Oke, mengerti dan setuju</BlButtonAv>
    </footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlHeaderMv} from '@bukalapak/bazaar-guild-mweb';
import {BlButtonAv, BlTextListMv} from '@bukalapak/bazaar-mweb-latest';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_TNC} from '../config/tracker-events';

export default {
  name: 'TermsAndCondition',
  components: {
    BlTextListMv,
    BlHeaderMv,
    BlButtonAv,
  },
  mixins: [trackerGenerator],
  computed: {
    ...mapGetters({getDetailCourse: 'courses/getDetailCourse'}),
  },
  created() {
    if (!this.getDetailCourse) this.$router.push({name: 'landing', query: this.$route.query});
  },
  mounted() {
    this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_TNC);
  },
  methods: {
    goToDetailPage() {
      const isLoggedIn = window.USER?.id;

      if (isLoggedIn) {
        this.$router.push({
          name: 'detail',
          params: {id: this.getDetailCourse.id},
          query: {...this.$route.query},
        });
      } else {
        const currentQueryParams = window.location.search.replace('?', '');
        const {isAndroid, isWebview} = window.USER?.agent ?? {};

        const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
        const encodedComebackUrl = window.encodeURIComponent(
          `${prefixHost}${process.env.BASE_PATH}/${this.getDetailCourse.id}?${currentQueryParams}`
        );

        window.location.replace(`${prefixHost}/login?comeback=${encodedComebackUrl}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  &__body {
    padding-bottom: 60px !important;
    top: 62px;
  }
}
</style>
